<template>
  <div class="container p-0 texto-principal">
    <div v-if="loading && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="text-center p-5">
      <div class="spinner-border texto-principal" role="status"></div>
      <p class="mt-2">{{ t('cargandoHorarios') }}</p>
    </div>
    
    <div v-if="!loading && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="w-100 mb-3">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 w-100 gap-3 px-1">
        <h5 class="text-start m-0 ms-1 d-flex align-items-center gap-2">
          <i class="bi bi-calendar3"></i>
          {{ t('horarioDocente') }} 
        </h5>

        <div class="d-flex flex-column">
          <div class="d-flex align-items-center justify-content-end gap-2 w-100">
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3 justify-content-center" 
                    @click.prevent="cambiarSemana(-7)" 
                    style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"/>
              </svg>
            </button>
            
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3 text-center fondo-terciario" v-model="periodoDesde" disabled/>
            </div>
            
            <p class="m-0 texto-principal">{{ $t('al') }}</p>
            
            <div>
              <input type="date" class="form-control form-control-sm sombra-sm p-2 rounded-3 text-center fondo-terciario" v-model="periodoHasta" disabled/>
            </div>
            
            <button class="btn fondo-terciario texto-principal sombra-sm d-flex align-items-center rounded-3 justify-content-center" 
                    @click.prevent="cambiarSemana(7)" 
                    style="height: 39px;">
              <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="listaHorariosDocente.length > 0 && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="w-100 position-relative pb-4">
      <div class="horario-grid-contenedor">
        
        <div class="grid-header-celda text-center fw-bold fondo-terciario texto-principal py-2 rounded sombra-sm z-2 position-relative">{{ t('Hora') }}</div>
        <div v-for="dia in diasSemana" :key="dia.id" class="grid-header-celda text-center fondo-terciario rounded sombra-sm py-2 z-2 position-relative">
          <div class="d-flex flex-column texto-principal">
            <span class="fw-bold">{{ t(dia.nombre) }}</span>
            <small class="texto-secundario fw-normal" style="font-size: 0.75rem;">{{ obtenerFechaDiaSemana(dia.id) }}</small>
          </div>
        </div>

        <div class="fondo-terciario rounded mb-1 sombra-sm" :style="{ gridColumn: 1, gridRow: `2 / ${ultimaFilaGrid+1}`, zIndex: 0 }"></div>
        <div v-for="dia in 5" :key="'fondo-dia-' + dia" class="fondo-terciario rounded mb-1 sombra-sm" :style="{ gridColumn: dia + 1, gridRow: `2 / ${ultimaFilaGrid+1}`, zIndex: 0 }"></div>


        <div v-for="marcador in marcadoresTiempo" :key="marcador.hora" :style="marcador.style" class="timeline-marcador">
          <span class="texto-principal">{{ marcador.hora }}</span>
        </div>

        <div v-for="dia in diasSemana" :key="dia.id" :style="obtenerEstiloColumnaDia(dia.id)" class="columna-dia-grid px-2">
          <div v-for="(item, index) in obtenerClasesDelDia(dia.id)" :key="`${item.ID_HorarioClase}-${index}`"
               @click="abrirModalDetalle(item)"
               class="fondo-terciario border-start rounded p-1 px-2 sombra d-flex flex-column justify-content-between text-start border-3 tarjeta-clase cursor-pointer"
               :class="[ item.Ausente ? 'borde-rojo-3' : item.EsSuplencia ? 'borde-violeta-3' : 'borde-azul-3', item.subSpan < 6 ? 'borde-3' : 'borde-4' ]"
               :style="obtenerEstiloTarjeta(item)"
               :title="`${item.Asignatura} (${item.Nivel} - ${item.Grupo})`">
            
            <div>
              <div class="fw-bold texto-principal d-block text-truncate" :class="item.subSpan < 6 ? 'fs-8' : 'fs-7'">
                {{ item.Asignatura }}
              </div>
              
              <div v-if="item.Aula" class="texto-secundario fs-9 d-block text-truncate">
                <i class="bi bi-geo-alt fs-9"></i> {{ item.Aula }}
              </div>

              <div class="texto-secundario fs-9 d-block text-truncate">
                <i class="bi bi-clock me-1"></i>{{ item.HoraDesde.substring(0, 5) }} a {{ item.HoraHasta.substring(0, 5) }} ({{ item.HoraClase }})
              </div>
            </div>

            <div v-if="item.Grupo || item.Nivel" class="d-flex flex-column gap-1 w-100" style="min-width: 0;">
              <span v-if="item.Nivel" 
                    class="badge fondo-secundario texto-principal d-block text-truncate text-center fs-9">
                {{ item.Nivel }}
              </span>
              <span v-if="item.Grupo" 
                    class="badge fondo-secundario texto-principal d-block text-truncate text-center fs-9">
                {{ item.Grupo }}
              </span>
            </div>

          </div>

        </div>

      </div>
    </div>

    <div v-if="!loading && listaHorariosDocente.length === 0 && (hasVerHorariosPermission || hasVerMisHorariosYFichadasPermission)" class="text-center p-5 fondo-terciario rounded-3 sombra-sm mt-2">
      <i class="bi bi-clock text-success fs-2"></i>
      <p class="m-0 mt-2 texto-secundario">{{ t('noSeEncontrarioHorarios') }}</p>
    </div>

    <div v-if="mostrarModalDetalle" class="modal-backdrop-custom d-flex justify-content-center align-items-center"
                @click="cerrarModalDetalle">
      <div class="modal-content-custom fondo-terciario rounded-3 sombra-lg p-4 position-relative border-start border-3"
          :class="[ claseSeleccionada.Ausente ? 'borde-rojo-3' : claseSeleccionada.EsSuplencia ? 'borde-violeta-3' : 'borde-azul-3']" 
          @click.stop>
        <button type="button" class="btn fondo-transparente border-0 position-absolute top-0 end-0 m-3" @click="cerrarModalDetalle" aria-label="Close">
          <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
              <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
              <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
            </g>
          </svg>
        </button>
        
        <h4 class="texto-principal mb-3 pe-4">{{ claseSeleccionada?.Asignatura }}</h4>
        
        <div class="d-flex flex-column gap-2 texto-principal">
          <div v-if="claseSeleccionada?.DiaSemana">
            <i class="bi bi-calendar3 me-2 texto-secundario"></i> 
            <strong>{{ t(diasSemana.find(d => d.id === claseSeleccionada.DiaSemana)?.nombre) }}</strong>
          </div>
          
          <div>
            <i class="bi bi-clock me-2 texto-secundario"></i> 
            {{ claseSeleccionada?.HoraDesde?.substring(0, 5) }} a {{ claseSeleccionada?.HoraHasta?.substring(0, 5) }} hs 
            <span class="texto-secundario fs-9 ms-1">({{ t('hora') }} {{ claseSeleccionada?.HoraClase }})</span>
          </div>

          <div v-if="claseSeleccionada?.Aula">
            <i class="bi bi-geo-alt me-2 texto-secundario"></i> 
            <strong>{{ t('aula') }}:</strong> {{ claseSeleccionada.Aula }}
          </div>

          <div v-if="claseSeleccionada?.Nivel">
            <i class="bi bi-layers me-2 texto-secundario"></i> 
            <strong>{{ t('nivel') }}:</strong> {{ claseSeleccionada.Nivel }}
          </div>

          <div v-if="claseSeleccionada?.Grupo" class=" d-block text-truncate">
            <i class="bi bi-people me-2 texto-secundario"></i> 
            <strong>{{ t('grupo') }}:</strong> {{ claseSeleccionada.Grupo }}
          </div>

          <div class="mt-2 d-flex gap-2 flex-wrap" v-if="claseSeleccionada?.EsSuplencia || claseSeleccionada?.Ausente">
            <span v-if="claseSeleccionada?.EsSuplencia" class="badge borde-violeta-3 texto-principal bg-transparent border">
              {{ t('suplencia') }}
            </span>
            <span v-if="claseSeleccionada?.Ausente" class="badge borde-rojo-3 texto-principal bg-transparent border">
              {{ t('ausente') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'HorariosSection',
  props: {
    persona: { type: Object, required: true },
  },
  setup(props) {
    const { t } = useI18n();
    const store = useStore();
    const user = computed(() => store.state.user);
    const loading = ref(false);
    const listaHorariosDocente = ref([]);
    
    const fechaLunesBase = ref(new Date());
    const periodoDesde = ref('');
    const periodoHasta = ref('');

    const hasVerHorariosPermission = ref(false);
    const hasVerMisHorariosYFichadasPermission = ref(false);

    const START_MINUTES = 450; 
    const INTERVALO_MINUTOS = 5; 

    const diasSemana = [
      { id: 1, nombre: 'Lunes' }, { id: 2, nombre: 'Martes' }, { id: 3, nombre: 'Miercoles' },
      { id: 4, nombre: 'Jueves' }, { id: 5, nombre: 'Viernes' }
    ];

    const mostrarModalDetalle = ref(false);
    const claseSeleccionada = ref(null);

    const abrirModalDetalle = (clase) => {
      claseSeleccionada.value = clase;
      mostrarModalDetalle.value = true;
      document.body.style.overflow = 'hidden'; // Evita que el fondo haga scroll
    };

    const cerrarModalDetalle = () => {
      mostrarModalDetalle.value = false;
      claseSeleccionada.value = null;
      document.body.style.overflow = 'auto'; // Restaura el scroll
    };

    const convertirAMinutos = (horaStr) => {
      if (!horaStr) return 0;
      const [horas, minutos] = horaStr.substring(0, 5).split(':').map(Number);
      return (horas * 60) + minutos;
    };

    const calcularFilaGrid = (horaStr, esFin = false) => {
      const minutos = convertirAMinutos(horaStr);
      const delta = minutos - START_MINUTES;
      const filaCalculada = delta / INTERVALO_MINUTOS;
      return Math.max(2, (esFin ? Math.ceil(filaCalculada) : Math.floor(filaCalculada)) + 2);
    };

    const obtenerEstiloColumnaDia = (diaId) => {
      return {
        gridColumn: `${diaId + 1}`,
        gridRow: `2 / ${ultimaFilaGrid.value}` // <- CAMBIADO
      };
    };

    // CALCULA DINÁMICAMENTE LA ÚLTIMA FILA A MOSTRAR EN LA GRILLA
    const ultimaFilaGrid = computed(() => {
      if (listaHorariosDocente.value.length === 0) return 122; // Por defecto si está vacío
      
      let maxFila = 0;
      listaHorariosDocente.value.forEach(item => {
        // Obtenemos la fila de fin de cada clase
        const filaFin = calcularFilaGrid(item.HoraHasta, true);
        if (filaFin > maxFila) {
          maxFila = filaFin;
        }
      });
      
      // Le sumamos un pequeño margen de filas (ej: 2 filas extra) para que respire visualmente el final
      return Math.max(maxFila, 60); 
    });

    // ALGORITMO OPTIMIZADO DETECTOR DE SOLAPAMIENTOS VARIABLES REUTILIZABLE
    const clasesProcesadasConPosicion = computed(() => {
      // 1. Convertir horas "HH:MM:SS" a minutos totales
      const clasesProcesadas = listaHorariosDocente.value.map(clase => {
        const [hDesde, mDesde] = clase.HoraDesde.split(':').map(Number);
        const [hHasta, mHasta] = clase.HoraHasta.split(':').map(Number);
        
        return {
          ...clase,
          inicioMin: hDesde * 60 + mDesde,
          finMin: hHasta * 60 + mHasta,
          colInterna: 0,
          procesada: false,
          subSpan: 6,
          subCol: 1
        };
      });

      const resultadoFinal = [];

      // Procesamos día por día
      for (let dia = 1; dia <= 5; dia++) {
        // CORRECCIÓN CRUCIAL: Ordenar las clases del día cronológicamente por hora de inicio
        const clasesDelDia = clasesProcesadas
          .filter(c => c.DiaSemana === dia)
          .sort((a, b) => a.inicioMin - b.inicioMin);
        
        let clusters = [];
        
        // 1. AGRUPACIÓN Y FUSIÓN DE CLUSTERS
        clasesDelDia.forEach(clase => {
          const clustersSolapados = clusters.filter(cluster => 
            cluster.some(c => clase.inicioMin < c.finMin && clase.finMin > c.inicioMin)
          );

          if (clustersSolapados.length === 0) {
            clusters.push([clase]);
          } else {
            const nuevoClusterFusionado = [clase];
            clustersSolapados.forEach(cluster => {
              nuevoClusterFusionado.push(...cluster);
            });
            
            clusters = clusters.filter(c => !clustersSolapados.includes(c));
            clusters.push(nuevoClusterFusionado);
          }
        });

        // 2. Procesar las dimensiones y posiciones de cada cluster
        clusters.forEach(cluster => {
          // Volvemos a ordenar internamente el cluster por hora de inicio para el barrido horizontal
          cluster.sort((a, b) => a.inicioMin - b.inicioMin);

          let maxColInternaDelCluster = 0;

          cluster.forEach(clase => {
            let colAsignada = 0;
            
            // CORRECCIÓN CRUCIAL: Buscamos conflictos ÚNICAMENTE con clases que realmente se crucen 
            // en la misma porción de tiempo exacta, permitiendo reutilizar columnas libres.
            let tieneConflicto = cluster.some(c => 
              c !== clase && 
              c.colInterna === colAsignada && 
              c.procesada && 
              clase.inicioMin < c.finMin && clase.finMin > c.inicioMin
            );

            while (tieneConflicto) {
              colAsignada++;
              tieneConflicto = cluster.some(c => 
                c !== clase && 
                c.colInterna === colAsignada && 
                c.procesada && 
                clase.inicioMin < c.finMin && clase.finMin > c.inicioMin
              );
            }

            clase.colInterna = colAsignada;
            clase.procesada = true;

            if (colAsignada > maxColInternaDelCluster) {
              maxColInternaDelCluster = colAsignada;
            }
          });

          // Determinar cuántas columnas reales paralelas máximas compiten al mismo tiempo en este cluster
          // Si el cluster es largo pero las materias no coexisten en el mismo minuto, no inflamos el denominador.
          const totalColumnasNecesarias = maxColInternaDelCluster + 1;
          const elSpan = Math.max(1, Math.floor(6 / totalColumnasNecesarias));

          // Asignamos el ancho y la posición horizontal final
          cluster.forEach(clase => {
            clase.subSpan = elSpan;
            clase.subCol = (clase.colInterna * elSpan) + 1;
            
            resultadoFinal.push(clase);
          });
        });
      }

      return resultadoFinal;
    });

    const obtenerClasesDelDia = (diaId) => {
      return clasesProcesadasConPosicion.value.filter(c => c.DiaSemana === diaId);
    };

    const obtenerEstiloTarjeta = (item) => {
      // Ajustamos las filas sincronizándolas con la subgrilla del contenedor del día (-1)
      const rowStart = calcularFilaGrid(item.HoraDesde) - 1;
      const rowEnd = calcularFilaGrid(item.HoraHasta, true) - 1;
      
      return {
        gridRow: `${rowStart} / ${rowEnd}`,
        gridColumn: `${item.subCol} / span ${item.subSpan}`
      };
    };

    const marcadoresTiempo = computed(() => {
      const horasUnicas = new Set();
      listaHorariosDocente.value.forEach(h => {
        if (h.HoraDesde) horasUnicas.add(h.HoraDesde.substring(0, 5));
        if (h.HoraHasta) horasUnicas.add(h.HoraHasta.substring(0, 5));
      });

      if (horasUnicas.size === 0) {
        ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00'].forEach(h => horasUnicas.add(h));
      }

      return Array.from(horasUnicas).map(hora => {
        const fila = calcularFilaGrid(hora);
        return {
          hora,
          style: {
            gridRow: `${fila}`,
            gridColumn: '1'
          }
        };
      });
    });

    const formatDateLocal = (dateObj) => {
      const year = dateObj.getFullYear();
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const day = String(dateObj.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const calcularLunes = (fecha) => {
      const d = new Date(fecha);
      const diaDeLaSemana = d.getDay() === 0 ? 7 : d.getDay(); 
      d.setDate(d.getDate() - diaDeLaSemana + 1);
      return d;
    };

    const actualizarRangoSemana = (lunesObj) => {
      fechaLunesBase.value = new Date(lunesObj);
      periodoDesde.value = formatDateLocal(lunesObj);
      
      const viernesObj = new Date(lunesObj);
      viernesObj.setDate(lunesObj.getDate() + 4);
      periodoHasta.value = formatDateLocal(viernesObj);

      localStorage.setItem('filtroPeriodoDesdeHorariosDocente', periodoDesde.value);
      fetchHorarios();
    };

    const obtenerFechaDiaSemana = (idDia) => {
      const d = new Date(fechaLunesBase.value);
      d.setDate(d.getDate() + (idDia - 1));
      return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}`;
    };

    const cambiarSemana = (dias) => {
      const nuevoLunes = new Date(fechaLunesBase.value);
      nuevoLunes.setDate(nuevoLunes.getDate() + dias);
      actualizarRangoSemana(nuevoLunes);
    };

    const checkAuth = async () => {
      let permisoAComprobar = 'VerHorarios';
      if (user.value.personasPermisos?.some(p => p.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(r => r.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))) {
        hasVerHorariosPermission.value = true;
      }
      
      permisoAComprobar = 'VerMisHorariosYFichadas';
      if (user.value.personasPermisos?.some(p => p.idPermisoNavigation?.permiso === permisoAComprobar) || 
        user.value.personasRoles?.some(r => r.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))) {
        if(props.persona.IdPersona === user.value.idPersona){
          hasVerMisHorariosYFichadasPermission.value = true;
        }
      }
    };

    const fetchHorarios = async () => {
      loading.value = true;
      const idUser = props.persona.IdPersona;
      try {
        const response = await api.get(`api/horarios/docente?semana=${periodoDesde.value}&idPersona=${idUser}`);
        listaHorariosDocente.value = response.data.HorariosAsignaturas || response.data || [];
        console.log('Horarios obtenidos:', listaHorariosDocente.value);
      } catch (error) {
        console.error('Error al obtener horarios:', error);
        listaHorariosDocente.value = [];
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; 

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload();
      }
      
      checkAuth();
      
      const storedDesde = localStorage.getItem('filtroPeriodoDesdeHorariosDocente');
      let fechaInicial = new Date();
      
      if (storedDesde) {
        const [year, month, day] = storedDesde.split('-');
        fechaInicial = new Date(year, month - 1, day);
      }

      const lunesInicial = calcularLunes(fechaInicial);
      actualizarRangoSemana(lunesInicial);
    });

    return {
      t,
      loading,
      listaHorariosDocente,
      periodoDesde,
      periodoHasta,
      diasSemana,
      marcadoresTiempo,
      hasVerHorariosPermission,
      hasVerMisHorariosYFichadasPermission,
      cambiarSemana,
      obtenerFechaDiaSemana,
      obtenerClasesDelDia,
      obtenerEstiloTarjeta,
      ultimaFilaGrid,
      obtenerEstiloColumnaDia,
      mostrarModalDetalle,
      claseSeleccionada,
      abrirModalDetalle,
      cerrarModalDetalle,
    };
  }
};
</script>

<style scoped>
/* ESTRUCTURA GRID CALENDARIO MAESTRO */
.horario-grid-contenedor {
  display: grid;
  /* El primer 10% es para las horas, el resto (1fr) se divide equitativamente entre los 5 días */
  grid-template-columns: 10% repeat(5, 1fr);
  grid-template-rows: auto; 
  grid-auto-rows: 7px;      
  gap: 6px;
  position: relative;
  width: 100%;
}

/* COLUMNA MAESTRA INDEPENDIENTE POR DÍA */
.columna-dia-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr); 
  grid-template-rows: auto; /* Quitamos el repeat fijo de aquí */
  grid-auto-rows: 7px;     /* <- CORRECCIÓN PARA COMPACTAR MÁXIMO LA SUB-GRILLA */
  row-gap: 6px;                          
  column-gap: 4px;                       
  position: relative;
  z-index: 1;
}

.grid-header-celda {
  grid-row: 1;
}

/* LA TARJETA INDIVIDUAL */
.tarjeta-clase {
  min-width: 0; 
  height: 100%;
  overflow: hidden;
  word-wrap: break-word;
}

/* EJE DE TIEMPO LATERAL */
.timeline-marcador {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  /* Mantenemos un índice alto para que los globos de horas resalten por encima de su fondo */
  z-index: 3; 
  /* transform: translateY(-7px); Centrar horizontalmente respecto a la línea */
}

.timeline-marcador span {
  position: absolute;
  top: 0;
  transform: translateY(-50%);
  font-size: 0.72rem;
  font-weight: bold;
  padding: 3px 5px;
  border-radius: 4px;
}

/* --- MODAL FLOTANTE --- */
.modal-backdrop-custom {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1050; /* Se asegura de estar por encima de todo */
  backdrop-filter: blur(2px); /* Efecto de desenfoque moderno opcional */
}

.modal-content-custom {
  width: 90%;
  max-width: 450px;
  background-color: #ffffff; /* Reemplazar por tu variable de color si 'fondo-terciario' no aplica el fondo base */
  animation: modalFadeIn 0.2s ease-out;
}

.cursor-pointer {
  cursor: pointer;
  transition: filter 0.2s;
}

.cursor-pointer:hover {
  filter: brightness(0.95); /* Pequeño efecto visual al pasar el mouse por la tarjeta */
}

@keyframes modalFadeIn {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>